import React, { useState, useEffect } from 'react';

// mui
import { Box, List, Stack } from '@mui/material';

// api
import { AdminObjectAdd, AdminObjectList, AdminObjectRemove, AdminObjectUpdate } from '../../../api';

import { def } from '@goldblack/shared';

// components
import { FilterItem, LoiseFiltersFilterInfoPanel, CommonYesNoDialog, AdminMenuBar, cloneObject } from '../..';

// client-shared
import { storage } from '@goldblack/client-storage';
import { ContainerScroll } from '@goldblack/client-comps';

function LoiseFiltersFilters() {
    const { loise } = storage.transience.getValue();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openDelete, setOpenDelete] = useState(false);

    function getFilter() {
        return loise.filter.data && loise.filter.data.length > 0 ? loise.filter.data[selectedIndex] : null;
    }

    const clickNew = () => {
        AdminObjectAdd('loise', 'filter', { name: 'Untitled', type: 'exact' }, () => {
            setSelectedIndex(loise.filter.data.length);
        });
    };

    const clickUpdate = () => {
        AdminObjectUpdate('loise', 'filter', getFilter());
    };

    const clickDelete = () => {
        if (getFilter()) setOpenDelete(true);
    };

    const onConfirmDelete = () => {
        setOpenDelete(false);
        AdminObjectRemove('loise', 'filter', getFilter()._id);
    };

    const clickItem = (index) => {
        setSelectedIndex(index);
    };

    const getOptionOption = () => {
        let options = [];
        for (const option of loise.filterOption.data) {
            options.push({ code: option.name, id: option._id });
        }
        return options;
    };

    const updateFilter = (filter) => {
        let callback = (type) => type._id === filter._id;
        storage.transience.updateState('loise.filter.data', callback, filter);
    };

    const clickSetActive = () => {
        let filter = cloneObject(getFilter());
        filter.status = def.FilterStatus.ACTIVE;
        updateFilter(filter);
    };

    const clickSetInactive = () => {
        let filter = cloneObject(getFilter());
        filter.status = def.FilterStatus.INACTIVE;
        updateFilter(filter);
    };

    const clickAddInputOption = () => {
        const option = { option: null, display: '{0}', width: 12, selection: 1 };
        let filter = cloneObject(getFilter());
        filter.inputOptions.push(option);
        updateFilter(filter);
    };

    const clickDeleteInputOption = () => {
        let filter = cloneObject(getFilter());
        filter.inputOptions.pop();
        updateFilter(filter);
    };

    const clickAddSearchOption = () => {
        const option = { option: null, width: 12, selection: 1 };
        let filter = cloneObject(getFilter());
        filter.searchOptions.push(option);
        updateFilter(filter);
    };

    const clickDeleteSearchOption = () => {
        let filter = cloneObject(getFilter());
        filter.searchOptions.pop();
        updateFilter(filter);
    };

    const clickAddAdminOption = () => {
        const option = { option: null, width: 12, selection: 1 };
        let filter = cloneObject(getFilter());
        filter.adminOptions.push(option);
        updateFilter(filter);
    };

    const clickDeleteAdminOption = () => {
        let filter = cloneObject(getFilter());
        filter.adminOptions.pop();
        updateFilter(filter);
    };

    const AdminFilterListPanel = () => {
        return (
            <ContainerScroll>
                <List>
                    {loise.filter.data.map((filter, index) => (
                        <FilterItem
                            key={filter._id}
                            filter={filter}
                            onClick={() => clickItem(index, filter)}
                            index={index}
                            selected={selectedIndex === index}
                        />
                    ))}
                </List>
            </ContainerScroll>
        );
    };

    useEffect(() => {
        if (loise.filter.data.length === 0) {
            AdminObjectList('loise', 'filter');
        }
        if (loise.filterOption.data.length === 0) {
            AdminObjectList('loise', 'filterOption');
        }
    }, []);

    const currentFilter = getFilter();

    const apiItems = [
        { label: 'New', onClick: clickNew },
        { label: 'Update', onClick: clickUpdate },
        { label: 'Delete', onClick: clickDelete },
    ];

    const editItems = [
        { label: 'Set Active', onClick: clickSetActive },
        { label: 'Set Inactive', onClick: clickSetInactive },
        { label: 'Add i-Opt', onClick: clickAddInputOption },
        { label: 'Del i-Opt', onClick: clickDeleteInputOption },
        { label: 'Add s-Opt', onClick: clickAddSearchOption },
        { label: 'Del s-Opt', onClick: clickDeleteSearchOption },
        { label: 'Add a-Opt', onClick: clickAddAdminOption },
        { label: 'Del a-Opt', onClick: clickDeleteAdminOption },
    ];

    return (
        <Stack direction='column' sx={{ p: 0, m: 0, width: '100%', height: '100%', minHeight: 0 }}>
            <CommonYesNoDialog
                open={openDelete}
                onClose={() => setOpenDelete(false)}
                title='Delete Filter'
                desc='Are you sure you want to delete this filter?'
                onYes={onConfirmDelete}
                onNo={() => setOpenDelete(false)}
            />
            <AdminMenuBar apiItems={apiItems} editItems={editItems} />
            <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
                {/* Left column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRight: 1,
                        borderColor: 'primary.main',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        <AdminFilterListPanel />
                    </Box>
                </Box>
                {/* Right column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        {currentFilter ? (
                            <LoiseFiltersFilterInfoPanel filter={currentFilter} options={getOptionOption()} />
                        ) : (
                            <></>
                        )}
                    </Box>
                </Box>
            </Box>
        </Stack>
    );
}

export { LoiseFiltersFilters };
